"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _toolkit = require('@reduxjs/toolkit');

var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);



/* Clinic branding for the patient app (clinic branding P-4), keyed by org.
 * Each patient chats response (GetInbox, chat load, the live chat push)
 * carries Clinics for the clinics of its chats, and its Orgs name those
 * clinics. A clinic the response names without branding (switched off,
 * no longer verified) is forgotten, so the next load shows it unbranded.
 * Accepted (review-app S-3): a failed branding read, or a patient past the
 * server's 100-clinic cap, looks the same, so those clinics show unbranded
 * until the next good load. */


const initialState = {}






exports. default = _toolkit.createReducer.call(void 0, 
  initialState,
  builder => {
    ;[
      _actionCreators2.default.getInboxActions.SUCCESS,
      _actionCreators2.default.getBlobjectDeepActions.SUCCESS,
      _actionCreators2.default.updateNotificationAction,
    ].forEach(
      // Mutate in place (Immer), so a response that changes nothing keeps
      // the slice's identity.
      t => builder.addCase(t, (s, a) => {
        const { Orgs, Clinics } = (_nullishCoalesce(a.payload, () => ( {}))) 
        for (const key of Object.keys(_nullishCoalesce(Orgs, () => ( {}))) ) {
          if (!_optionalChain([Clinics, 'optionalAccess', _ => _[key]]) && s[key]) delete s[key]
        }
        for (const [key, clinic] of Object.entries(_nullishCoalesce(Clinics, () => ( {}))) ) {
          if (JSON.stringify(s[key]) !== JSON.stringify(clinic)) s[key] = clinic
        }
      }),
    )
    builder.addCase(_actionCreators2.default.logoutAction, () => initialState)
  },
)
